import React from 'react';
import Button from '@material-ui/core/Button';

// Single rendering of a refused login (HIA-BUG-20260929-4): the message of the refusal `kind`
// (see auth/challengeErrors.js) and a "Recommencer" button that resets the login state.
// Used in place of the form by both the ID login box and the QR login box.
const LoginRefusal = ({ refusal, onRestart }) => (
    <div className="loginRefusal" role="alert" data-kind={refusal.kind} style={{ textAlign: 'center', padding: '16px 8px' }}>
        <p className="loginRefusalMessage" style={{ color: '#1d2454', fontWeight: 600, marginBottom: 20 }}>
            {refusal.message}
        </p>
        <Button type="button" color="primary" onClick={onRestart}>
            Recommencer
        </Button>
    </div>
);

export default LoginRefusal;
